import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {PendingDocService} from '../../../services/pending-doc.service';
import {PendingDoc} from '../../../models/pending-doc';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import {DocumentService} from 'src/app/services/document.service';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {MemberService} from 'src/app/services/member.service';
import {FolderService} from 'src/app/services/folder.service';
import {DocumentApproveDialogComponent} from '../document-approve-dialog/document-approve-dialog.component';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-document-dialog',
  templateUrl: './document-dialog.component.html',
  styleUrls: [ './document-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class DocumentDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;
  public pendingDoc: PendingDoc;

  //public displayedColumns: string[] = [ 'icon', 'date', 'filename', 'approved', 'proofOfVaccine', 'delete' ];
  public displayedColumns: string[] = [ 'icon', 'date', 'filename', 'approved', 'edit', 'delete' ];

  public folders: any[] = []

  constructor (
    private fs: AngularFireStorage,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _pendingDocService: PendingDocService,
    private _folderService: FolderService,
    public _documentService: DocumentService,
    private _memberService: MemberService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    public _spinnerService: SpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pendingDoc = this.data.doc;
    this.folders = this.data.folders

    this._documentService.getDocumentsByMember(this.pendingDoc.member_id, this.folders)
  }

  ngOnInit () {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.pendingDoc.id != "0") {
      this.isEdit = true;
    } else {
      this.isEdit = false
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.pendingDoc, this.entityForm)

  }

  openApproveDialog (entity) {
    let dialogRef = this.dialog.open(DocumentApproveDialogComponent, {
      width: '600px',
      height: '400px',
      panelClass: 'custom-dialog-container',
      data: entity
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const formData: FormGroup = response[ 0 ];
        const selectedFolder: any = response[ 1 ];
        const data = formData.getRawValue()

        if (!selectedFolder) {
          data.folder_id = ''
        }

        this.update(entity.id, data.approved, data.folder_id)
      })

  }

  update (doc_id: string, approved: boolean, folder_id: string) {

    console.log('doc_id: ' + doc_id)
    console.log('approved: ' + approved)
    console.log('folder_id: ' + folder_id)
    console.log('this.pendingDoc.id: ' + this.pendingDoc.id)

    const waiting = this._spinnerService.show();

    this._documentService.updateApproveDocument(doc_id, approved, folder_id)
      .then(() => {

        this._pendingDocService.approved(this.pendingDoc.id, approved)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso", '', 'sucess');
          })
          .catch((error) => {
            console.log("error: " + JSON.stringify(error))
            this.snackBar.openSnackBar("Erro", '', 'error');
          })
          .finally(() => {
            waiting.close()
          })
      })
      .catch((error) => {
        console.log("error: " + JSON.stringify(error))
      })
      .finally(() => {
        waiting.close()
      })


  }

  /*
    update () {
  
      this.spinner = true
      let isAllApproved: boolean = true
  
      let count: number = 0
      let allData = this._documentService.documentDataSource.data;
  
      allData.forEach((item) => {
        // console.log("data.id: " + item.id + " - " + item.approved)
  
        if (isAllApproved) {
          isAllApproved = item.approved
        }
  
        this._documentService.updateApproveDocument(item.id, item.approved, item.proofOfVaccine, '', '')
          .then(() => {
  
            if (item.proofOfVaccine) {
              this._memberService.updateProofOfVaccine(this.data.member_id, true)
                .then(() => {
                  console.log("member updated")
                })
                .catch((err) => {
                  console.log("erro upadate image: " + JSON.stringify(err))
                })
            }
  
            count++
            if (count >= this._documentService.documentDataSource.data.length) {
  
              //   console.log("this.pendingDoc.id: " + this.pendingDoc.id)
              //   console.log("final result: " + count + " - " + isAllApproved)
              //   console.log("obs: " + this.entityForm.controls.obs.value)
  
              this._pendingDocService.approved(this.pendingDoc.id, isAllApproved, this.entityForm.controls.obs.value)
                .then(() => {
                  this.snackBar.openSnackBar("Sucesso", '', 'sucess');
                })
                .catch((error) => {
                  console.log("error: " + JSON.stringify(error))
                  this.snackBar.openSnackBar("Erro", '', 'error');
                })
                .finally(() => {
                  this.spinner = false
                })
            }
  
          })
          .catch((error) => {
            console.log("error: " + JSON.stringify(error))
          })
          .finally(() => {
            this.spinner = false
          })
  
      })
  
    }
  */

  createEntity (data: any): PendingDoc {

    let entity = new PendingDoc();

    entity.id = data.id;
    entity.pending = data.pending;
    entity.sent = data.sent;
    entity.approved = data.approved;
    entity.proofOfVaccine = data.proofOfVaccine;

    entity.member_name = data.member_name;
    entity.member_id = data.member_id;

    entity.product_name = data.product_name;
    entity.product_id = data.product_id;

    entity.date = data.date;
    entity.obs = data.obs;

    return entity;
  }

  setFormValues (data, form) {
    form.controls.id.setValue(data.id);
    form.controls.pending.setValue(data.pending);
    form.controls.sent.setValue(data.sent);
    form.controls.approved.setValue(data.approved);
    form.controls.proofOfVaccine.setValue(data.proofOfVaccine);
    form.controls.member_name.setValue(data.member_name);
    form.controls.member_id.setValue(data.member_id);
    form.controls.product_name.setValue(data.product_name);
    form.controls.product_id.setValue(data.product_id);
    form.controls.date.setValue(data.date);
    form.controls.obs.setValue(data.obs);
  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      pending: new FormControl(''),
      sent: new FormControl(''),
      approved: new FormControl(''),
      proofOfVaccine: new FormControl(''),
      member_name: new FormControl(''),
      member_id: new FormControl(''),
      product_name: new FormControl(''),
      product_id: new FormControl(''),
      date: new FormControl(''),
      obs: new FormControl('')
    });
    return form
  }

  goToLink (url: string) {
    window.open(url, "_blank");
  }

  deleteDocument (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.filename + "<br><br>Excluir documento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._documentService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
              // Get a reference to the storage service, which is used to create references in your storage bucket
              var storage = this.fs.storage;
              // Create a storage reference from our storage service
              var storageRef = storage.ref();
              // Create a reference to the file to delete
              const path = 'documents/' + this.data.member_id + '/' + element.filename
              var desertRef = storageRef.child(path);
              // Delete the file
              desertRef.delete().then(function () {
                console.log("success")
              }).catch(function (error) {
                console.log("error: " + JSON.stringify(error))
              });
            }
          )
          .catch(
            (error) => {console.log("delete document error: " + error.message)}
          )

      }
    })
  }

}
